/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Prompt_HintInputs */

const cs_property_ai_prompt_hint = /** @type {(inputs: Property_Ai_Prompt_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použije se pro vylepšení i staging u této fotky.`)
};

const en_property_ai_prompt_hint = /** @type {(inputs: Property_Ai_Prompt_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for enhance and staging on this photo.`)
};

/**
* | output |
* | --- |
* | "Used for enhance and staging on this photo." |
*
* @param {Property_Ai_Prompt_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_prompt_hint = /** @type {((inputs?: Property_Ai_Prompt_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Prompt_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_prompt_hint(inputs)
	return cs_property_ai_prompt_hint(inputs)
});